// src/auth/PrivateRoute.js
import React from "react";
import { Route, Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { user } = useAuth(); // Get the user from AuthProvider

  console.log(user);

  return user ? <Outlet /> : <Navigate to="/login" />;
};

// const PrivateRoute = ({ component: Component, ...rest }) => {
//     const { isAuthenticated } = useAuth();
//     return (
//       <Route
//         {...rest}
//         render={(props) =>
//           isAuthenticated ? <Component {...props} /> : <Redirect to="/login" />
//         }
//       />
//     );
//   };

export default PrivateRoute;
